export default "__VITE_ASSET__ujd6cyMx__"